import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { pricingActions } from "..";
import _ from "lodash";
import { RootState } from "@src/store/store";
import { EventInventoryRecord, getInventoryCacheEventId } from "@src/store/pricing/queryEventInventoryAllSlice";

const initialState = false;
export interface IListingToUpdate {
	listing_id: number;
	price: number;
	face: null | number;
	floorPrice?: number;
	ceilingPrice?: number;
}
export const { thunk: updateListingPrices, slice: updateListingPricesSlice } = getThunkAndSlice<
	Array<IListingToUpdate>,
	typeof initialState
>({
	initialState,
	path: "/api/Pricing/UpdateListingPrices",
	method: "post",
	onAfterRequest: async (data, params, state, dispatch) => {
		const rootState = state as RootState;
		const eventId = getInventoryCacheEventId(rootState);
		const priceMap = new Map<number, number>();

		params.forEach((param) => {
			priceMap.set(param.listing_id, Number(param.price));
		});

		const newData = rootState.pricing.eventInventoryAll.data.map((event) => {
			const newItemPrice = priceMap.get(event.Listing_ID);
			return {
				...event,
				Item_Price: !_.isNil(newItemPrice) && !event.Invoice_ID ? newItemPrice : event.Item_Price,
			};
		});
		dispatch(pricingActions.updateInventoryAll({ data: newData, eventId }));

		if (rootState.pricing.globalInventory.data.length) {
			const newGlobalData = (rootState.pricing.globalInventory.data as Array<EventInventoryRecord>).map((item) => {
				const newPrice = priceMap.get(item.Listing_ID);
				return {
					...item,
					Listing_Price: !_.isNil(newPrice) && !item.Invoice_ID ? newPrice : item.Listing_Price,
				};
			});
			dispatch(pricingActions.updateGlobalInventory({ data: newGlobalData }));
		}

		return data;
	},
});
